import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TopBar } from "../components/UI";

const API = process.env.REACT_APP_API_URL || "https://g6fw4rjkvb.execute-api.eu-central-1.amazonaws.com/prototype";
const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

// Landing page of the "Approve pre-fill" button in the monthly booking-slot
// email (see shared/slot_prefill.py). The signed single-use token in the URL
// authorizes the approval, so no sign-in is needed. Approval is a POST made
// from this page (not a GET on the emailed link) so mail-scanner link
// prefetching can't approve on the owner's behalf.
export default function SlotPrefillApprovePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const id = params.get("id");
  const token = params.get("token");
  const [state, setState] = useState({ status: id && token ? "working" : "error", error: "Invalid approval link.", result: null });
  const started = useRef(false);

  useEffect(() => {
    if (!id || !token || started.current) return;
    started.current = true;
    (async () => {
      try {
        const r = await fetch(`${API}/manage/prefill/approve`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, token }),
        });
        const d = await r.json();
        if (!r.ok) throw new Error(d.error || "Could not approve the pre-fill.");
        setState({ status: "done", result: d });
      } catch (e) {
        setState({ status: "error", error: e.message });
      }
    })();
  }, [id, token]);

  const res = state.result;
  const month = res?.month_start ? `${MONTHS[parseInt(res.month_start.slice(5, 7), 10) - 1]} ${res.month_start.slice(0, 4)}` : "";
  return (
    <div style={{ minHeight: "100vh", background: "#F2F5EC" }}>
      <TopBar title="Wine4Collect" />
      <div style={{ maxWidth: 440, margin: "60px auto", padding: "0 16px" }}>
        <div style={{ background: "white", borderRadius: 12, padding: 32, border: "1px solid #C4D0A8", textAlign: "center" }}>
          {state.status === "working" && <p style={{ color: "#6A7E58" }}>Approving your pre-fill…</p>}
          {state.status === "done" && (
            <>
              <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, color: "#3D4A1A", margin: "0 0 8px" }}>Pre-fill approved</h2>
              <p style={{ fontSize: 13, color: "#6A7E58", lineHeight: 1.5 }}>
                {res.created} booking slot{res.created === 1 ? "" : "s"} added for <strong>{res.winery_name}</strong> in {month}.
                {res.skipped?.length > 0 && ` ${res.skipped.length} skipped (closed, past or outside working hours).`}
              </p>
              <button onClick={() => navigate(`/manage?tab=availability&winery=${res.winery_id}&month=${res.month_start.slice(0, 7)}`)}
                style={{ marginTop: 12, padding: "10px 20px", borderRadius: 8, border: "none", background: "#3D4A1A", color: "white", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
                Open winery manager
              </button>
            </>
          )}
          {state.status === "error" && (
            <>
              <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, color: "#8B1A2F", margin: "0 0 8px" }}>Couldn't approve</h2>
              <p style={{ fontSize: 13, color: "#6A7E58", lineHeight: 1.5 }}>{state.error}</p>
              <button onClick={() => navigate("/manage?tab=availability")}
                style={{ marginTop: 12, padding: "10px 20px", borderRadius: 8, border: "1px solid #C4D0A8", background: "white", color: "#3D4A1A", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
                Go to winery manager
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
